export default __webpack_public_path__ + "static/media/ajax2.99d35828.png";